import React, { useRef } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
export function App() {
  const ctaEndRef = useRef<HTMLDivElement>(null);
  return <div className="min-h-screen w-full bg-cream font-sans text-navy" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero ctaEndRef={ctaEndRef} data-id="element-3" />
        <Stats data-id="element-4" />
        <Testimonials title="Lo que dicen las maestras que ya lo tienen" variant="first" data-id="element-5" />
        <Problem data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonos data-id="element-8" />
        <Offer data-id="element-9" />
        <Testimonials title="❤️ Más docentes que ya lo tienen" variant="second" data-id="element-10" />
        <Guarantee data-id="element-11" />
        <Faq data-id="element-12" />
        <CostSection data-id="element-13" />
        <FinalCta data-id="element-14" />
        <Footer data-id="element-15" />
      </main>
      <FloatingCta triggerRef={ctaEndRef} data-id="element-16" />
    </div>;
}